<form class="form" [formGroup]="dmForm" (ngSubmit)="submit()">
  @if (!store.submit.dmPlugin()) {
    <label for="to" i18n>To:</label>
    <div class="form-array skip-margin">
      <input class="preview grow"
             type="text"
             [value]="preview()"
             [title]="previewTitle()"
             [style.display]="preview() ? 'block' : 'none'"
             (focus)="clickPreview(toInput)">
      <datalist id="to-list">
        @for (o of autocomplete(); track o.value) {
          <option [value]="o.value">{{ o.label }}</option>
        }
      </datalist>
      <input #toInput
             id="to"
             i18n-placeholder placeholder="Myself"
             [formControl]="to"
             type="text"
             inputmode="email"
             autocorrect="off"
             autocapitalize="none"
             list="to-list"
             [class.hidden-without-removing]="preview()"
             [appAutofocus]="!store.submit.to().length"
             (input)="search(toInput)"
             (blur)="blur(toInput)"
             (focusin)="edit(toInput)"
             (focus)="edit(toInput)"
             (focusout)="getPreview(toInput.value)">
    </div>
    @if (toMissing()) {
      <div><!-- Warning --></div>
      <div>
          <div class="warning" i18n> Message to myself</div>
      </div>
    }
  }

  <label for="title" i18n>Title:</label>
  <input id="title" type="text" [formControl]="title">

  <app-select-plugin [picker]="true"
                     class="shrink"
                     [text]="true"
                     i18n-title title="Add Plugin"
                     (picked)="bookmarks.toggleTag($event)" />
  <app-form-plugins id="plugins" [group]="dmForm" [values]="pluginValues()" />

  @if (customEditor()) {
    <span><!-- Editor --></span>
    <div class="fill-editor">
      <ngx-monaco-editor #ed
                         [formControl]="comment"
                         [options]="codeOptions()"
                         [style.height]="'min(200px, 90vh)'"
                                           appResizeHandle
                         [hitArea]="config.mobile() ? 48 : 20" />
    </div>
  } @else {
    <label [for]="ed.id()" i18n>Message:</label>
    <div class="fill-editor">
      <app-editor #ed
                  class="bubble"
                  [control]="comment"
                   (syncEditor)="syncEditor()"
                  [tags]="tags"
                  (syncTags)="setTags($event)"
                  (addSource)="addSource($event)"
                  (uploadCompleted)="addCompletedUpload($event)"
                  [autoFocus]="!!store.submit.dmPlugin() || !!store.submit.to().length" />
    </div>
  }

  <app-tags [group]="dmForm" />

  @for (e of serverError(); track e) {
    <span><!-- Unexpected Error --></span>
    <div class="error">{{ e }}</div>
  }

  <span><!-- Buttons --></span>
  <span class="buttons right floating">
    @if (submitting() || saving()) {
      <app-loading [inline]="true" />
    }
    @if (admin.getPlugin('plugin/editing')) {
      <button type="button" [disabled]="submitting() || saving() || submitted() || dmFormPristine()" (click)="saveForLater(true)" i18n>Save for later</button>
    }
    <button type="submit" [disabled]="submitting() || (submitted() && !dmFormValid())" i18n>Send</button>
  </span>
</form>
